import React, { useEffect } from 'react';
import { Overlay, Tooltip } from '@repo/components/tooltips';
import { Section, SettingsSectionBox, SettingsSectionLabel } from '@views/Settings/components';
import styles from './ClayProfile.module.scss';
import { ContactHeader } from '@repo/components/headers';
import { useDispatch, useSelector } from 'react-redux';
import { fetchContact, selectContact } from '@repo/redux/actions/contacts';
import analytics from '@repo/utils/helpers/analytics';
import { useNavigate } from 'react-router-dom';
import { PenIcon, ClayProfileIcon } from '@repo/icons';
import { closeSettings } from '@repo/redux/actions/ui';
import { ID } from '@repo/utils/types';

export default function ClayProfile({ contactID }: { contactID: ID }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userProfile = useSelector(selectContact(contactID));

  const editProfile = () => {
    analytics.track('Profile Edited');
    dispatch(closeSettings);
    navigate(`/contact/self/form`);
  };

  const viewProfile = () => {
    analytics.track('Profile Viewed');
    dispatch(closeSettings);
    navigate(`/contact/${contactID}`);
  };

  useEffect(() => {
    dispatch(fetchContact({ id: contactID }));
  }, []);

  return (
    <>
      <Section>
        <SettingsSectionLabel>Your Profile</SettingsSectionLabel>
        <SettingsSectionBox className={styles.box}>
          <ContactHeader className={styles.preview} contact={userProfile} sidebar />
          <div className={styles.buttons}>
            <Tooltip placement="bottom" overlay={<Overlay>View Profile</Overlay>}>
              <ClayProfileIcon onClick={viewProfile} />
            </Tooltip>
            <Tooltip placement="bottom" overlay={<Overlay>Edit Profile</Overlay>}>
              <PenIcon className={styles.btn} onClick={editProfile} />
            </Tooltip>
          </div>
        </SettingsSectionBox>
      </Section>
    </>
  );
}
